import { useEffect, useState } from 'react';
import Cookies from 'js-cookie'

import Header from '@components/Header';
import ColumnChart from '@components/Charts/ColumnChart';
import Table from '@components/Table';

import BackgroundDark from '@assets/login-background.jpg';
import BackgroundLight from '@assets/background-light.jpg';
import { Cancel } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

import './LabourForecast.scss';

const Graphs = () => {
    const [darkMode] = useState<boolean>(Cookies.get('darkMode') === "true");

    const [disappearingSkills, setDisappearingSkills] = useState<any>([]);
    const [growthInTopSkills, setGrowthInTopSkills] = useState<any>([]);
    /*const [elementaryOccupations, setElementaryOccupations] = useState<any>([]);*/
    const [topGrowingSkills, setTopGrowingSkills] = useState<any>([]);
    const [growthElementaryOccupations, setGrowthElementaryOccupations] = useState<any>([]);
    const [demandedSkills, setDemandedSkills] = useState<any>([]);
    const [demandSkillsInOccupation, setDemandSkillsInOccupation] = useState<any>([]);
    const navigate = useNavigate();

	const demandSkillsInOccupationCols = [
		{
			"key": "FIELD1",
			"label": ""
		},
		{
			"key": "Management",
			"label": "Management"
		},
		{
			"key": "Sales",
			"label": "Sales"
		},
		{
			"key": "Planning",
			"label": "Planning"
		},
		{
			"key": "Operations",
			"label": "Operations"
		},
		{
			"key": "Leadership",
			"label": "Leadership"
		},
		{
			"key": "Project Management",
			"label": "Project Management"
		},
		{
			"key": "Research",
			"label": "Research"
		},
		{
			"key": "Infrastructure",
			"label": "Infrastructure"
		},
		{
			"key": "Consulting",
			"label": "Consulting"
		},
		{
			"key": "Innovation",
			"label": "Innovation"
		},
		{
			"key": "Writing",
			"label": "Writing"
		},
		{
			"key": "Accounting",
			"label": "Accounting"
		},
		{
			"key": "Finance",
			"label": "Finance"
		},
		{
			"key": "Problem Solving",
			"label": "Problem Solving"
		},
		{
			"key": "Procurement",
			"label": "Procurement"
		},
		{
			"key": "Customer Service",
			"label": "Customer Service"
		},
		{
			"key": "Communications",
			"label": "Communications"
		},
		{
			"key": "Business Development",
			"label": "Business Development"
		},
		{
			"key": "Social Media",
			"label": "Social Media"
		},
		{
			"key": "Supply Chain",
			"label": "Supply Chain"
		},
		{
			"key": "Written Communication",
			"label": "Written Communication"
		},
		{
			"key": "Analytics",
			"label": "Analytics"
		},
		{
			"key": "Negotiation",
			"label": "Negotiation"
		},
		{
			"key": "Logistics",
			"label": "Logistics"
		},
		{
			"key": "Troubleshooting (Problem Solving)",
			"label": "Troubleshooting (Problem Solving)"
		},
		{
			"key": "Time Management",
			"label": "Time Management"
		},
		{
			"key": "Scheduling",
			"label": "Scheduling"
		},
		{
			"key": "Presentations",
			"label": "Presentations"
		},
		{
			"key": "Collaboration",
			"label": "Collaboration"
		},
		{
			"key": "Forecasting",
			"label": "Forecasting"
		},
		{
			"key": "Risk Management",
			"label": "Risk Management"
		},
		{
			"key": "Installation",
			"label": "Installation"
		},
		{
			"key": "Budgeting",
			"label": "Budgeting"
		},
		{
			"key": "Supervision",
			"label": "Supervision"
		},
		{
			"key": "Governance",
			"label": "Governance"
		},
		{
			"key": "SQL (Programming Language)",
			"label": "SQL (Programming Language)"
		},
		{
			"key": "Microsoft Office",
			"label": "Microsoft Office"
		},
		{
			"key": "Integration",
			"label": "Integration"
		},
		{
			"key": "Professional Services",
			"label": "Professional Services"
		},
		{
			"key": "Automation",
			"label": "Automation"
		},
		{
			"key": "Financial Statements",
			"label": "Financial Statements"
		},
		{
			"key": "Sourcing",
			"label": "Sourcing"
		},
		{
			"key": "Quality Assurance",
			"label": "Quality Assurance"
		},
		{
			"key": "Banking",
			"label": "Banking"
		},
		{
			"key": "Business Process",
			"label": "Business Process"
		},
		{
			"key": "Real Estate",
			"label": "Real Estate"
		},
		{
			"key": "Coordinating",
			"label": "Coordinating"
		},
		{
			"key": "Quality Control",
			"label": "Quality Control"
		},
		{
			"key": "Digital Marketing",
			"label": "Digital Marketing"
		},
		{
			"key": "Market Research",
			"label": "Market Research"
		},
		{
			"key": "Management Systems",
			"label": "Management Systems"
		},
		{
			"key": "Purchasing",
			"label": "Purchasing"
		},
		{
			"key": "Commissioning",
			"label": "Commissioning"
		},
		{
			"key": "Hospitality",
			"label": "Hospitality"
		},
		{
			"key": "Account Management",
			"label": "Account Management"
		},
		{
			"key": "Performance Management",
			"label": "Performance Management"
		},
		{
			"key": "Service Provider",
			"label": "Service Provider"
		},
		{
			"key": "AutoCAD",
			"label": "AutoCAD"
		},
		{
			"key": "Sustainability",
			"label": "Sustainability"
		},
		{
			"key": "Requisition",
			"label": "Requisition"
		},
		{
			"key": "Software Development",
			"label": "Software Development"
		},
		{
			"key": "Filing",
			"label": "Filing"
		},
		{
			"key": "E-Commerce",
			"label": "E-Commerce"
		},
		{
			"key": "Python (Programming Language)",
			"label": "Python (Programming Language)"
		},
		{
			"key": "Service Delivery",
			"label": "Service Delivery"
		},
		{
			"key": "Detail Oriented",
			"label": "Detail Oriented"
		},
		{
			"key": "Java (Programming Language)",
			"label": "Java (Programming Language)"
		},
		{
			"key": "Surveys",
			"label": "Surveys"
		},
		{
			"key": "Editing",
			"label": "Editing"
		},
		{
			"key": "Billing",
			"label": "Billing"
		},
		{
			"key": "Onboarding",
			"label": "Onboarding"
		},
		{
			"key": "Cash Flows",
			"label": "Cash Flows"
		},
		{
			"key": "Reconciliation",
			"label": "Reconciliation"
		},
		{
			"key": "Process Improvements",
			"label": "Process Improvements"
		},
		{
			"key": "Business Acumen",
			"label": "Business Acumen"
		},
		{
			"key": "Calculations",
			"label": "Calculations"
		},
		{
			"key": "Information Technology",
			"label": "Information Technology"
		},
		{
			"key": "Investigation",
			"label": "Investigation"
		},
		{
			"key": "Reliability",
			"label": "Reliability"
		},
		{
			"key": "Construction Management",
			"label": "Construction Management"
		},
		{
			"key": "Cyber Security",
			"label": "Cyber Security"
		},
		{
			"key": "Linux",
			"label": "Linux"
		},
		{
			"key": "Accountability",
			"label": "Accountability"
		},
		{
			"key": "Merchandising",
			"label": "Merchandising"
		},
		{
			"key": "Graphic Design",
			"label": "Graphic Design"
		},
		{
			"key": "Branding",
			"label": "Branding"
		},
		{
			"key": "Cleanliness",
			"label": "Cleanliness"
		},
		{
			"key": "Financial Data",
			"label": "Financial Data"
		},
		{
			"key": "Facility Management",
			"label": "Facility Management"
		},
		{
			"key": "Employee Benefits",
			"label": "Employee Benefits"
		},
		{
			"key": "Voltage",
			"label": "Voltage"
		},
		{
			"key": "Scrum (Software Development)",
			"label": "Scrum (Software Development)"
		},
		{
			"key": "Career Development",
			"label": "Career Development"
		},
		{
			"key": "Visualization",
			"label": "Visualization"
		},
		{
			"key": "High Voltage",
			"label": "High Voltage"
		}
	];

    useEffect(() => {
        async function fetchCountries() {
            setDisappearingSkills && setDisappearingSkills([
                {
                    "name": "Product Design",
                    "value": -2.05
                },
                {
                    "name": "Operation Centers",
                    "value": -1.35
                },
                {
                    "name": "Management Consulting",
                    "value": -1.19
                },
                {
                    "name": "Innovation",
                    "value": -0.88
                },
                {
                    "name": "Recall (Memory)",
                    "value": -0.58
                },
                {
                    "name": "Supply Chain",
                    "value": -0.55
                },
                {
                    "name": "IT Infrastructure",
                    "value": -0.54
                },
                {
                    "name": "People Management",
                    "value": -0.5
                },
                {
                    "name": "Artificial Intelligence",
                    "value": -0.48
                },
                {
                    "name": "Enterprise Application Software",
                    "value": -0.44
                }
            ]);

            setGrowthInTopSkills && setGrowthInTopSkills([
                {
                    "name": "Management",
                    "value": 4.49
                },
                {
                    "name": "Sales",
                    "value": 1.1
                },
                {
                    "name": "Planning",
                    "value": 1.9
                },
                {
                    "name": "Operations",
                    "value": 2.11
                },
                {
                    "name": "Leadership",
                    "value": 1.89
                },
                {
                    "name": "Project Management",
                    "value": 0.89
                },
                {
                    "name": "Research",
                    "value": 2.92
                },
                {
                    "name": "Infrastructure",
                    "value": 0.58
                },
                {
                    "name": "Consulting",
                    "value": -0.04
                },
                {
                    "name": "Innovation",
                    "value": -0.88
                }
            ]);

            //setElementaryOccupations && setElementaryOccupations([
            //    {
            //        "name": "AL - Baha",
            //        "value": 8.4
            //    },
            //    {
            //        "name": "AL - Jouf",
            //        "value": 7.7
            //    },
            //    {
            //        "name": "Asir",
            //        "value": 7.7
            //    },
            //    {
            //        "name": "Easte. Prov.",
            //        "value": 6.6
            //    },
            //    {
            //        "name": "Hail",
            //        "value": 8.9
            //    },
            //    {
            //        "name": "Jazan",
            //        "value": 8.6
            //    },
            //    {
            //        "name": "Madinah",
            //        "value": 7.2
            //    },
            //    {
            //        "name": "Makkah",
            //        "value": 6.2
            //    },
            //    {
            //        "name": "Najran",
            //        "value": 9.2
            //    },
            //    {
            //        "name": "North.Bord.",
            //        "value": 8.3
            //    },
            //    {
            //        "name": "Qassim",
            //        "value": 9.7
            //    },
            //    {
            //        "name": "Riyadh",
            //        "value": 6.9
            //    },
            //    {
            //        "name": "Tabuk",
            //        "value": 7.4
            //    }
            //]);

            setTopGrowingSkills && setTopGrowingSkills([
                {
                    "name": "Management",
                    "value": 4.49
                },
                {
                    "name": "Research",
                    "value": 2.92
                },
                {
                    "name": "Problem Solving",
                    "value": 2.71
                },
                {
                    "name": "Customer Service",
                    "value": 2.11
                },
                {
                    "name": "Operations",
                    "value": 2.11
                },
                {
                    "name": "Planning",
                    "value": 1.9
                },
                {
                    "name": "Leadership",
                    "value": 1.89
                },
                {
                    "name": "Collaboration",
                    "value": 1.67
                },
                {
                    "name": "Hospitality",
                    "value": 1.39
                },
                {
                    "name": "Time Management",
                    "value": 1.14
                }
            ]);

            setGrowthElementaryOccupations && setGrowthElementaryOccupations([
                {
                    "name": "Clerical support workers",
                    "value": 16528
                },
                {
                    "name": "Craft and related trades workers",
                    "value": 0
                },
                {
                    "name": "Elementary occupations",
                    "value": 39534
                },
                {
                    "name": "Managers",
                    "value": 5194
                },
                {
                    "name": "Other Occuption",
                    "value": 0
                },
                {
                    "name": "Plant and machine operators, and assemblers",
                    "value": -3410
                },
                {
                    "name": "Professionals",
                    "value": 23877
                },
                {
                    "name": "Service and sales workers",
                    "value": 16314
                },
                {
                    "name": "Skilled agricultural, forestry and fishery workers",
                    "value": 66
                },
                {
                    "name": "Technicians and associate professionals",
                    "value": 9856
                }
            ]);

            setDemandedSkills && setDemandedSkills([
                {
                    "name": "Management",
                    "value": 124384
                },
                {
                    "name": "Sales",
                    "value": 51219
                },
                {
                    "name": "Planning",
                    "value": 47011
                },
                {
                    "name": "Operations",
                    "value": 42953
                },
                {
                    "name": "Leadership",
                    "value": 32815
                },
                {
                    "name": "Research",
                    "value": 29476
                },
                {
                    "name": "Project Management",
                    "value": 24296
                },
                {
                    "name": "Problem Solving",
                    "value": 22759
                },
                {
                    "name": "Customer Service",
                    "value": 18541
                },
                {
                    "name": "Consulting",
                    "value": 18128
                }
            ]);

            setDemandSkillsInOccupation && setDemandSkillsInOccupation([
                {
                    "companyName": "Test",
                    "numJobs": 1000
                }
			]);

            setDemandSkillsInOccupation && setDemandSkillsInOccupation([
                {
                    "FIELD1": "Clerical support workers",
                    "Management": 20250,
                    "Sales": 8339,
                    "Planning": 7654,
                    "Operations": 6993,
                    "Leadership": 5342,
                    "Project Management": 3955,
                    "Research": 4799,
                    "Infrastructure": 2763,
                    "Consulting": 2951,
                    "Innovation": 1472,
                    "Writing": 2416,
                    "Accounting": 2599,
                    "Finance": 2584,
                    "Problem Solving": 3705,
                    "Procurement": 1525,
                    "Customer Service": 3018,
                    "Communications": 2043,
                    "Business Development": 2552,
                    "Social Media": 2303,
                    "Supply Chain": 1110,
                    "Written Communication": 1927,
                    "Analytics": 2165,
                    "Negotiation": 1691,
                    "Logistics": 1943,
                    "Troubleshooting (Problem Solving)": 1903,
                    "Time Management": 1980,
                    "Scheduling": 1547,
                    "Presentations": 1738,
                    "Collaboration": 2139,
                    "Forecasting": 1386,
                    "Risk Management": 1434,
                    "Installation": 892,
                    "Budgeting": 1133,
                    "Supervision": 1281,
                    "Governance": 769,
                    "SQL (Programming Language)": 1360,
                    "Microsoft Office": 1163,
                    "Integration": 961,
                    "Professional Services": 1173,
                    "Automation": 1185,
                    "Financial Statements": 982,
                    "Sourcing": 1265,
                    "Quality Assurance": 551,
                    "Banking": 693,
                    "Business Process": 1234,
                    "Real Estate": 974,
                    "Coordinating": 676,
                    "Quality Control": 876,
                    "Digital Marketing": 744,
                    "Market Research": 1137,
                    "Management Systems": 849,
                    "Purchasing": 953,
                    "Commissioning": 584,
                    "Hospitality": 1453,
                    "Account Management": 988,
                    "Performance Management": 610,
                    "Service Provider": 824,
                    "AutoCAD": 796,
                    "Sustainability": 955,
                    "Requisition": 791,
                    "Software Development": 721,
                    "Filing": 498,
                    "E-Commerce": 954,
                    "Python (Programming Language)": 1026,
                    "Service Delivery": 667,
                    "Detail Oriented": 758,
                    "Java (Programming Language)": 945,
                    "Surveys": 751,
                    "Editing": 647,
                    "Billing": 717,
                    "Onboarding": 784,
                    "Cash Flows": 647,
                    "Reconciliation": 535,
                    "Process Improvements": 522,
                    "Business Acumen": 515,
                    "Calculations": 610,
                    "Information Technology": 592,
                    "Investigation": 493,
                    "Reliability": 700,
                    "Construction Management": 764,
                    "Cyber Security": 541,
                    "Linux": 537,
                    "Accountability": 886,
                    "Merchandising": 695,
                    "Graphic Design": 589,
                    "Branding": 490,
                    "Cleanliness": 603,
                    "Financial Data": 603,
                    "Facility Management": 561,
                    "Employee Benefits": 655,
                    "Voltage": 859,
                    "Scrum (Software Development)": 540,
                    "Career Development": 577,
                    "Visualization": 513,
                    "High Voltage": 656
                },
                {
                    "FIELD1": "Elementary occupations",
                    "Management": 44412,
                    "Sales": 18288,
                    "Planning": 16786,
                    "Operations": 15337,
                    "Leadership": 11717,
                    "Project Management": 8676,
                    "Research": 10525,
                    "Infrastructure": 6061,
                    "Consulting": 6473,
                    "Innovation": 3230,
                    "Writing": 5300,
                    "Accounting": 5701,
                    "Finance": 5667,
                    "Problem Solving": 8127,
                    "Procurement": 3344,
                    "Customer Service": 6621,
                    "Communications": 4480,
                    "Business Development": 5597,
                    "Social Media": 5052,
                    "Supply Chain": 2434,
                    "Written Communication": 4226,
                    "Analytics": 4749,
                    "Negotiation": 3709,
                    "Logistics": 4263,
                    "Troubleshooting (Problem Solving)": 4175,
                    "Time Management": 4344,
                    "Scheduling": 3393,
                    "Presentations": 3813,
                    "Collaboration": 4692,
                    "Forecasting": 3040,
                    "Risk Management": 3145,
                    "Installation": 1957,
                    "Budgeting": 2486,
                    "Supervision": 2809,
                    "Governance": 1686,
                    "SQL (Programming Language)": 2982,
                    "Microsoft Office": 2552,
                    "Integration": 2109,
                    "Professional Services": 2573,
                    "Automation": 2600,
                    "Financial Statements": 2154,
                    "Sourcing": 2776,
                    "Quality Assurance": 1209,
                    "Banking": 1521,
                    "Business Process": 2707,
                    "Real Estate": 2137,
                    "Coordinating": 1483,
                    "Quality Control": 1922,
                    "Digital Marketing": 1633,
                    "Market Research": 2494,
                    "Management Systems": 1863,
                    "Purchasing": 2090,
                    "Commissioning": 1282,
                    "Hospitality": 3187,
                    "Account Management": 2168,
                    "Performance Management": 1339,
                    "Service Provider": 1807,
                    "AutoCAD": 1747,
                    "Sustainability": 2096,
                    "Requisition": 1736,
                    "Software Development": 1582,
                    "Filing": 1092,
                    "E-Commerce": 2094,
                    "Python (Programming Language)": 2250,
                    "Service Delivery": 1462,
                    "Detail Oriented": 1662,
                    "Java (Programming Language)": 2073,
                    "Surveys": 1647,
                    "Editing": 1420,
                    "Billing": 1573,
                    "Onboarding": 1720,
                    "Cash Flows": 1420,
                    "Reconciliation": 1175,
                    "Process Improvements": 1146,
                    "Business Acumen": 1129,
                    "Calculations": 1338,
                    "Information Technology": 1300,
                    "Investigation": 1083,
                    "Reliability": 1535,
                    "Construction Management": 1677,
                    "Cyber Security": 1188,
                    "Linux": 1179,
                    "Accountability": 1944,
                    "Merchandising": 1524,
                    "Graphic Design": 1293,
                    "Branding": 1075,
                    "Cleanliness": 1323,
                    "Financial Data": 1324,
                    "Facility Management": 1230,
                    "Employee Benefits": 1436,
                    "Voltage": 1884,
                    "Scrum (Software Development)": 1185,
                    "Career Development": 1266,
                    "Visualization": 1125,
                    "High Voltage": 1439
                },
                {
                    "FIELD1": "Managers",
                    "Management": 6305,
                    "Sales": 2596,
                    "Planning": 2383,
                    "Operations": 2177,
                    "Leadership": 1663,
                    "Project Management": 1231,
                    "Research": 1494,
                    "Infrastructure": 860,
                    "Consulting": 919,
                    "Innovation": 458,
                    "Writing": 752,
                    "Accounting": 809,
                    "Finance": 804,
                    "Problem Solving": 1153,
                    "Procurement": 474,
                    "Customer Service": 939,
                    "Communications": 636,
                    "Business Development": 794,
                    "Social Media": 717,
                    "Supply Chain": 345,
                    "Written Communication": 600,
                    "Analytics": 674,
                    "Negotiation": 526,
                    "Logistics": 605,
                    "Troubleshooting (Problem Solving)": 592,
                    "Time Management": 616,
                    "Scheduling": 481,
                    "Presentations": 541,
                    "Collaboration": 666,
                    "Forecasting": 431,
                    "Risk Management": 446,
                    "Installation": 277,
                    "Budgeting": 352,
                    "Supervision": 398,
                    "Governance": 239,
                    "SQL (Programming Language)": 423,
                    "Microsoft Office": 362,
                    "Integration": 299,
                    "Professional Services": 365,
                    "Automation": 369,
                    "Financial Statements": 305,
                    "Sourcing": 394,
                    "Quality Assurance": 171,
                    "Banking": 216,
                    "Business Process": 384,
                    "Real Estate": 303,
                    "Coordinating": 210,
                    "Quality Control": 272,
                    "Digital Marketing": 231,
                    "Market Research": 354,
                    "Management Systems": 264,
                    "Purchasing": 296,
                    "Commissioning": 182,
                    "Hospitality": 452,
                    "Account Management": 307,
                    "Performance Management": 190,
                    "Service Provider": 256,
                    "AutoCAD": 248,
                    "Sustainability": 297,
                    "Requisition": 246,
                    "Software Development": 224,
                    "Filing": 155,
                    "E-Commerce": 297,
                    "Python (Programming Language)": 319,
                    "Service Delivery": 207,
                    "Detail Oriented": 236,
                    "Java (Programming Language)": 294,
                    "Surveys": 233,
                    "Editing": 201,
                    "Billing": 223,
                    "Onboarding": 244,
                    "Cash Flows": 201,
                    "Reconciliation": 166,
                    "Process Improvements": 162,
                    "Business Acumen": 160,
                    "Calculations": 190,
                    "Information Technology": 184,
                    "Investigation": 153,
                    "Reliability": 217,
                    "Construction Management": 238,
                    "Cyber Security": 168,
                    "Linux": 167,
                    "Accountability": 276,
                    "Merchandising": 216,
                    "Graphic Design": 183,
                    "Branding": 152,
                    "Cleanliness": 187,
                    "Financial Data": 187,
                    "Facility Management": 174,
                    "Employee Benefits": 203,
                    "Voltage": 267,
                    "Scrum (Software Development)": 168,
                    "Career Development": 179,
                    "Visualization": 159,
                    "High Voltage": 204
                },
                {
                    "FIELD1": "Plant and machine operators, and assemblers",
                    "Management": -3304,
                    "Sales": -1360,
                    "Planning": -1249,
                    "Operations": -1141,
                    "Leadership": -871,
                    "Project Management": -645,
                    "Research": -783,
                    "Infrastructure": -451,
                    "Consulting": -481,
                    "Innovation": -240,
                    "Writing": -394,
                    "Accounting": -424,
                    "Finance": -421,
                    "Problem Solving": -604,
                    "Procurement": -248,
                    "Customer Service": -492,
                    "Communications": -333,
                    "Business Development": -416,
                    "Social Media": -375,
                    "Supply Chain": -181,
                    "Written Communication": -314,
                    "Analytics": -353,
                    "Negotiation": -275,
                    "Logistics": -317,
                    "Troubleshooting (Problem Solving)": -310,
                    "Time Management": -323,
                    "Scheduling": -252,
                    "Presentations": -283,
                    "Collaboration": -349,
                    "Forecasting": -226,
                    "Risk Management": -234,
                    "Installation": -145,
                    "Budgeting": -184,
                    "Supervision": -209,
                    "Governance": -125,
                    "SQL (Programming Language)": -221,
                    "Microsoft Office": -189,
                    "Integration": -156,
                    "Professional Services": -191,
                    "Automation": -193,
                    "Financial Statements": -160,
                    "Sourcing": -206,
                    "Quality Assurance": -90,
                    "Banking": -113,
                    "Business Process": -201,
                    "Real Estate": -159,
                    "Coordinating": -110,
                    "Quality Control": -143,
                    "Digital Marketing": -121,
                    "Market Research": -185,
                    "Management Systems": -138,
                    "Purchasing": -155,
                    "Commissioning": -95,
                    "Hospitality": -237,
                    "Account Management": -161,
                    "Performance Management": -99,
                    "Service Provider": -134,
                    "AutoCAD": -130,
                    "Sustainability": -155,
                    "Requisition": -129,
                    "Software Development": -117,
                    "Filing": -81,
                    "E-Commerce": -155,
                    "Python (Programming Language)": -167,
                    "Service Delivery": -108,
                    "Detail Oriented": -123,
                    "Java (Programming Language)": -154,
                    "Surveys": -122,
                    "Editing": -105,
                    "Billing": -117,
                    "Onboarding": -128,
                    "Cash Flows": -105,
                    "Reconciliation": -87,
                    "Process Improvements": -85,
                    "Business Acumen": -84,
                    "Calculations": -99,
                    "Information Technology": -96,
                    "Investigation": -80,
                    "Reliability": -114,
                    "Construction Management": -124,
                    "Cyber Security": -88,
                    "Linux": -87,
                    "Accountability": -144,
                    "Merchandising": -113,
                    "Graphic Design": -96,
                    "Branding": -80,
                    "Cleanliness": -98,
                    "Financial Data": -98,
                    "Facility Management": -91,
                    "Employee Benefits": -106,
                    "Voltage": -140,
                    "Scrum (Software Development)": -88,
                    "Career Development": -94,
                    "Visualization": -83,
                    "High Voltage": -107
                },
                {
                    "FIELD1": "Professionals",
                    "Management": 29253,
                    "Sales": 12046,
                    "Planning": 11056,
                    "Operations": 10102,
                    "Leadership": 7718,
                    "Project Management": 5714,
                    "Research": 6932,
                    "Infrastructure": 3992,
                    "Consulting": 4263,
                    "Innovation": 2127,
                    "Writing": 3491,
                    "Accounting": 3755,
                    "Finance": 3732,
                    "Problem Solving": 5353,
                    "Procurement": 2203,
                    "Customer Service": 4361,
                    "Communications": 2951,
                    "Business Development": 3686,
                    "Social Media": 3327,
                    "Supply Chain": 1603,
                    "Written Communication": 2783,
                    "Analytics": 3128,
                    "Negotiation": 2443,
                    "Logistics": 2808,
                    "Troubleshooting (Problem Solving)": 2750,
                    "Time Management": 2861,
                    "Scheduling": 2235,
                    "Presentations": 2511,
                    "Collaboration": 3090,
                    "Forecasting": 2002,
                    "Risk Management": 2071,
                    "Installation": 1289,
                    "Budgeting": 1637,
                    "Supervision": 1850,
                    "Governance": 1111,
                    "SQL (Programming Language)": 1964,
                    "Microsoft Office": 1681,
                    "Integration": 1389,
                    "Professional Services": 1695,
                    "Automation": 1712,
                    "Financial Statements": 1419,
                    "Sourcing": 1828,
                    "Quality Assurance": 796,
                    "Banking": 1002,
                    "Business Process": 1783,
                    "Real Estate": 1407,
                    "Coordinating": 977,
                    "Quality Control": 1266,
                    "Digital Marketing": 1075,
                    "Market Research": 1643,
                    "Management Systems": 1227,
                    "Purchasing": 1377,
                    "Commissioning": 844,
                    "Hospitality": 2099,
                    "Account Management": 1428,
                    "Performance Management": 882,
                    "Service Provider": 1190,
                    "AutoCAD": 1151,
                    "Sustainability": 1380,
                    "Requisition": 1143,
                    "Software Development": 1042,
                    "Filing": 719,
                    "E-Commerce": 1379,
                    "Python (Programming Language)": 1482,
                    "Service Delivery": 963,
                    "Detail Oriented": 1095,
                    "Java (Programming Language)": 1365,
                    "Surveys": 1085,
                    "Editing": 935,
                    "Billing": 1036,
                    "Onboarding": 1133,
                    "Cash Flows": 935,
                    "Reconciliation": 774,
                    "Process Improvements": 755,
                    "Business Acumen": 743,
                    "Calculations": 881,
                    "Information Technology": 856,
                    "Investigation": 713,
                    "Reliability": 1011,
                    "Construction Management": 1104,
                    "Cyber Security": 782,
                    "Linux": 776,
                    "Accountability": 1280,
                    "Merchandising": 1004,
                    "Graphic Design": 851,
                    "Branding": 708,
                    "Cleanliness": 871,
                    "Financial Data": 872,
                    "Facility Management": 810,
                    "Employee Benefits": 946,
                    "Voltage": 1241,
                    "Scrum (Software Development)": 780,
                    "Career Development": 834,
                    "Visualization": 741,
                    "High Voltage": 948
                },
                {
                    "FIELD1": "Service and sales workers",
                    "Management": 17289,
                    "Sales": 7119,
                    "Planning": 6534,
                    "Operations": 5970,
                    "Leadership": 4561,
                    "Project Management": 3377,
                    "Research": 4097,
                    "Infrastructure": 2359,
                    "Consulting": 2520,
                    "Innovation": 1257,
                    "Writing": 2063,
                    "Accounting": 2219,
                    "Finance": 2206,
                    "Problem Solving": 3163,
                    "Procurement": 1302,
                    "Customer Service": 2577,
                    "Communications": 1744,
                    "Business Development": 2179,
                    "Social Media": 1966,
                    "Supply Chain": 947,
                    "Written Communication": 1645,
                    "Analytics": 1848,
                    "Negotiation": 1443,
                    "Logistics": 1659,
                    "Troubleshooting (Problem Solving)": 1625,
                    "Time Management": 1691,
                    "Scheduling": 1320,
                    "Presentations": 1484,
                    "Collaboration": 1826,
                    "Forecasting": 1183,
                    "Risk Management": 1224,
                    "Installation": 762,
                    "Budgeting": 967,
                    "Supervision": 1093,
                    "Governance": 656,
                    "SQL (Programming Language)": 1161,
                    "Microsoft Office": 993,
                    "Integration": 821,
                    "Professional Services": 1001,
                    "Automation": 1012,
                    "Financial Statements": 838,
                    "Sourcing": 1080,
                    "Quality Assurance": 470,
                    "Banking": 592,
                    "Business Process": 1053,
                    "Real Estate": 831,
                    "Coordinating": 577,
                    "Quality Control": 748,
                    "Digital Marketing": 635,
                    "Market Research": 971,
                    "Management Systems": 725,
                    "Purchasing": 813,
                    "Commissioning": 499,
                    "Hospitality": 1241,
                    "Account Management": 844,
                    "Performance Management": 521,
                    "Service Provider": 703,
                    "AutoCAD": 680,
                    "Sustainability": 816,
                    "Requisition": 676,
                    "Software Development": 616,
                    "Filing": 425,
                    "E-Commerce": 815,
                    "Python (Programming Language)": 876,
                    "Service Delivery": 569,
                    "Detail Oriented": 647,
                    "Java (Programming Language)": 807,
                    "Surveys": 641,
                    "Editing": 553,
                    "Billing": 612,
                    "Onboarding": 669,
                    "Cash Flows": 552,
                    "Reconciliation": 457,
                    "Process Improvements": 446,
                    "Business Acumen": 439,
                    "Calculations": 521,
                    "Information Technology": 506,
                    "Investigation": 421,
                    "Reliability": 597,
                    "Construction Management": 652,
                    "Cyber Security": 462,
                    "Linux": 459,
                    "Accountability": 757,
                    "Merchandising": 593,
                    "Graphic Design": 503,
                    "Branding": 418,
                    "Cleanliness": 515,
                    "Financial Data": 515,
                    "Facility Management": 479,
                    "Employee Benefits": 559,
                    "Voltage": 733,
                    "Scrum (Software Development)": 461,
                    "Career Development": 493,
                    "Visualization": 438,
                    "High Voltage": 560
                },
                {
                    "FIELD1": "Skilled agricultural, forestry and fishery workers",
                    "Management": 35,
                    "Sales": 14,
                    "Planning": 13,
                    "Operations": 12,
                    "Leadership": 9,
                    "Project Management": 7,
                    "Research": 8,
                    "Infrastructure": 4,
                    "Consulting": 5,
                    "Innovation": 2,
                    "Writing": 4,
                    "Accounting": 4,
                    "Finance": 4,
                    "Problem Solving": 6,
                    "Procurement": 2,
                    "Customer Service": 5,
                    "Communications": 3,
                    "Business Development": 4,
                    "Social Media": 4,
                    "Supply Chain": 1,
                    "Written Communication": 3,
                    "Analytics": 3,
                    "Negotiation": 3,
                    "Logistics": 3,
                    "Troubleshooting (Problem Solving)": 3,
                    "Time Management": 3,
                    "Scheduling": 2,
                    "Presentations": 3,
                    "Collaboration": 3,
                    "Forecasting": 2,
                    "Risk Management": 2,
                    "Installation": 1,
                    "Budgeting": 2,
                    "Supervision": 2,
                    "Governance": 1,
                    "SQL (Programming Language)": 2,
                    "Microsoft Office": 2,
                    "Integration": 1,
                    "Professional Services": 2,
                    "Automation": 2,
                    "Financial Statements": 1,
                    "Sourcing": 2,
                    "Quality Assurance": 0,
                    "Banking": 1,
                    "Business Process": 2,
                    "Real Estate": 1,
                    "Coordinating": 1,
                    "Quality Control": 1,
                    "Digital Marketing": 1,
                    "Market Research": 2,
                    "Management Systems": 1,
                    "Purchasing": 1,
                    "Commissioning": 1,
                    "Hospitality": 2,
                    "Account Management": 1,
                    "Performance Management": 1,
                    "Service Provider": 1,
                    "AutoCAD": 1,
                    "Sustainability": 1,
                    "Requisition": 1,
                    "Software Development": 1,
                    "Filing": 0,
                    "E-Commerce": 1,
                    "Python (Programming Language)": 1,
                    "Service Delivery": 1,
                    "Detail Oriented": 1,
                    "Java (Programming Language)": 1,
                    "Surveys": 1,
                    "Editing": 1,
                    "Billing": 1,
                    "Onboarding": 1,
                    "Cash Flows": 1,
                    "Reconciliation": 0,
                    "Process Improvements": 0,
                    "Business Acumen": 0,
                    "Calculations": 1,
                    "Information Technology": 1,
                    "Investigation": 0,
                    "Reliability": 1,
                    "Construction Management": 1,
                    "Cyber Security": 0,
                    "Linux": 0,
                    "Accountability": 1,
                    "Merchandising": 1,
                    "Graphic Design": 1,
                    "Branding": 0,
                    "Cleanliness": 1,
                    "Financial Data": 1,
                    "Facility Management": 0,
                    "Employee Benefits": 1,
                    "Voltage": 1,
                    "Scrum (Software Development)": 0,
                    "Career Development": 1,
                    "Visualization": 0,
                    "High Voltage": 1
                },
                {
                    "FIELD1": "Technicians and associate professionals",
                    "Management": 10144,
                    "Sales": 4177,
                    "Planning": 3834,
                    "Operations": 3503,
                    "Leadership": 2676,
                    "Project Management": 1981,
                    "Research": 2404,
                    "Infrastructure": 1384,
                    "Consulting": 1478,
                    "Innovation": 737,
                    "Writing": 1210,
                    "Accounting": 1302,
                    "Finance": 1294,
                    "Problem Solving": 1856,
                    "Procurement": 763,
                    "Customer Service": 1512,
                    "Communications": 1023,
                    "Business Development": 1278,
                    "Social Media": 1153,
                    "Supply Chain": 556,
                    "Written Communication": 965,
                    "Analytics": 1084,
                    "Negotiation": 847,
                    "Logistics": 973,
                    "Troubleshooting (Problem Solving)": 953,
                    "Time Management": 992,
                    "Scheduling": 775,
                    "Presentations": 871,
                    "Collaboration": 1071,
                    "Forecasting": 694,
                    "Risk Management": 718,
                    "Installation": 447,
                    "Budgeting": 567,
                    "Supervision": 641,
                    "Governance": 385,
                    "SQL (Programming Language)": 681,
                    "Microsoft Office": 582,
                    "Integration": 481,
                    "Professional Services": 587,
                    "Automation": 593,
                    "Financial Statements": 492,
                    "Sourcing": 634,
                    "Quality Assurance": 276,
                    "Banking": 347,
                    "Business Process": 618,
                    "Real Estate": 488,
                    "Coordinating": 338,
                    "Quality Control": 439,
                    "Digital Marketing": 373,
                    "Market Research": 569,
                    "Management Systems": 425,
                    "Purchasing": 477,
                    "Commissioning": 292,
                    "Hospitality": 728,
                    "Account Management": 495,
                    "Performance Management": 306,
                    "Service Provider": 412,
                    "AutoCAD": 399,
                    "Sustainability": 478,
                    "Requisition": 396,
                    "Software Development": 361,
                    "Filing": 249,
                    "E-Commerce": 478,
                    "Python (Programming Language)": 514,
                    "Service Delivery": 334,
                    "Detail Oriented": 379,
                    "Java (Programming Language)": 473,
                    "Surveys": 376,
                    "Editing": 324,
                    "Billing": 359,
                    "Onboarding": 393,
                    "Cash Flows": 324,
                    "Reconciliation": 268,
                    "Process Improvements": 261,
                    "Business Acumen": 257,
                    "Calculations": 305,
                    "Information Technology": 296,
                    "Investigation": 247,
                    "Reliability": 350,
                    "Construction Management": 383,
                    "Cyber Security": 271,
                    "Linux": 269,
                    "Accountability": 444,
                    "Merchandising": 348,
                    "Graphic Design": 295,
                    "Branding": 245,
                    "Cleanliness": 302,
                    "Financial Data": 302,
                    "Facility Management": 281,
                    "Employee Benefits": 328,
                    "Voltage": 430,
                    "Scrum (Software Development)": 270,
                    "Career Development": 289,
                    "Visualization": 257,
                    "High Voltage": 328
                }
            ]);
        }

        fetchCountries();
    }, []); // eslint-disable-line


    return (
        <div>
            <Header />
            <div className="graph">
                <div className="graph__content">
                    <div className="graph__headerSection"> <div className="graph__lableSection"> <h2 className="graph__title">Labour Forecast</h2></div> <div className="graph__closeSection"> <Cancel type="button" onClick={() => navigate('/dashboard')}  className="graph__close-button" /></div></div>
                   
                   
                    <div className="mb-3">
                        <div className="col-12 mb-3">
                            <div className="widget-component">
                                <h4 className="border-bottom mb-2 pb-2">
                                    Disappearing skills in 2025 
                                </h4>
                                {disappearingSkills && disappearingSkills.length > 0 ?
                                    <div>
                                        <div id="chart1">
                                            <ColumnChart name="chart1" data={disappearingSkills} titleY="Percent" avoidSorting />
                                        </div>
                                    </div>
                                    :
                                    <div className="na">N/A</div>
                                }
                            </div>
                        </div>
                        <div className="col-12 mb-3">
                            <div className="widget-component">
                                <h4 className="border-bottom mb-2 pb-2">
                                    Growth in 10 demanded skills in 2025
                                </h4>
                                {growthInTopSkills && growthInTopSkills.length > 0 ?
                                    <div>
                                        <div id="chart2">
                                            <ColumnChart name="chart2" data={growthInTopSkills} titleY="Percent" avoidSorting />
                                        </div>
                                    </div>
                                    :
                                    <div className="na">N/A</div>
                                }
                            </div>
                        </div>
                        {/*<div className="col-12 mb-3">*/}
                        {/*    <div className="widget-component">*/}
                        {/*        <h4 className="border-bottom mb-2 pb-2">*/}
                        {/*            However, the results are regionally differentiated, here for 'Elementary occupations'*/}
                        {/*        </h4>*/}
                        {/*        {elementaryOccupations && elementaryOccupations.length > 0 ?*/}
                        {/*            <div>*/}
                        {/*                <div id="chart3">*/}
                        {/*                    <ColumnChart name="chart3" data={elementaryOccupations} titleY="Percent" avoidSorting />*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*            :*/}
                        {/*            <div className="na">N/A</div>*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className="col-12 mb-3">
                            <div className="widget-component">
                                <h4 className="border-bottom mb-2 pb-2">
                                    Top growing skills in 2025
                                </h4>
                                {topGrowingSkills && topGrowingSkills.length > 0 ?
                                    <div>
                                        <div id="chart4">
                                            <ColumnChart name="chart4" data={topGrowingSkills} titleY="Percent" avoidSorting />
                                        </div>
                                    </div>
                                    :
                                    <div className="na">N/A</div>
                                }
                            </div>
                        </div>
                        <div className="col-12 mb-3">
                            <div className="widget-component">
                                <h4 className="border-bottom mb-2 pb-2">
                                    The method does pick up on country characteristics as we can see from the staggering growth in Elementary occupations 
                                </h4>
                                {growthElementaryOccupations && growthElementaryOccupations.length > 0 ?
                                    <div>
                                        <div id="chart5">
                                            <ColumnChart name="chart5" data={growthElementaryOccupations} titleY="People" avoidSorting />
                                        </div>
                                    </div>
                                    :
                                    <div className="na">N/A</div>
                                }
                            </div>
                        </div>
                        <div className="col-12 mb-3">
                            <div className="widget-component">
                                <h4 className="border-bottom mb-2 pb-2">
                                    Top 10 demanded skills in 2025
                                </h4>
                                {demandedSkills && demandedSkills.length > 0 ?
                                    <div>
                                        <div id="chart6">
                                            <ColumnChart name="chart6" data={demandedSkills} titleY="Number" avoidSorting />
                                        </div>
                                    </div>
                                    :
                                    <div className="na">N/A</div>
                                }
                            </div>
                        </div>
                        <div className="col-12 mb-3">
                            <div className="widget-component">
                                <h4 className="border-bottom mb-2 pb-2">
                                    Projected change in number of workers with skill X per occupation
                                </h4>
                                {demandSkillsInOccupation && demandSkillsInOccupation.length > 0 ?
                                    <div>
                                        <div id="chart7">
                                            <Table id="chart7" columns={demandSkillsInOccupationCols} data={demandSkillsInOccupation} />
                                        </div>
                                    </div>
                                    :
                                    <div className="na">N/A</div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    className="graph__background"
                    style={{ backgroundImage: `url(${darkMode ? BackgroundDark : BackgroundLight})` }}
                />

                <div className="graph__mask" />
            </div>
        </div>
    );
};

export default Graphs;
